import { useApolloClient } from '@apollo/client';

import { AuthStatusDocument, GetCurrentUserDocument } from '@graphql/requests';

import { apiRestClient } from '@ui-furniture/clients/api-rest-client';

export const useEnsureUserHasProfileAndIsAuthenticated = () => {
  const client = useApolloClient();

  const ensureUserHasProfileAndIsAuthenticated = async () => {
    await apiRestClient.authenticateVisitor();
    await client.refetchQueries({
      include: [AuthStatusDocument, GetCurrentUserDocument],
    });
  };

  return ensureUserHasProfileAndIsAuthenticated;
};
